import { render, staticRenderFns } from "./tasks-info.vue?vue&type=template&id=ac835808&scoped=true"
import script from "./tasks-info.vue?vue&type=script&lang=js"
export * from "./tasks-info.vue?vue&type=script&lang=js"
import style0 from "./tasks-info.vue?vue&type=style&index=0&id=ac835808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac835808",
  null
  
)

export default component.exports